module.exports = __webpack_public_path__ + "static/media/glanum_therme.612f53b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Provence/glanum_therme.png
// module id = 723
// module chunks = 0